import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "ecl-cookie-consent";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      setVisible(true);
    }
  }, []);

  const respond = (choice) => {
    localStorage.setItem(STORAGE_KEY, choice);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      className="position-fixed bottom-0 start-0 end-0 p-3"
      style={{ zIndex: 1080 }}
    >
      <div
        className="container d-flex flex-column flex-md-row align-items-md-center gap-3 rounded-3 p-3 shadow"
        style={{ backgroundColor: "#081428", color: "#cfd9e6" }}
      >
        <p className="mb-0 flex-grow-1" style={{ fontSize: "0.9rem" }}>
          We use cookies to improve our service and analyze how our website is
          used. You can accept or refuse them, see our{" "}
          <Link to="/privacy" style={{ color: "#00aaff" }}>
            Privacy Policy
          </Link>{" "}
          for details.
        </p>
        <div className="d-flex gap-2 flex-shrink-0">
          <button
            type="button"
            className="btn btn-sm btn-outline-light"
            onClick={() => respond("declined")}
          >
            Decline
          </button>
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => respond("accepted")}
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
